import { render, staticRenderFns } from "./AddOrUpdateGoods.vue?vue&type=template&id=7b2becf4&scoped=true"
import script from "./AddOrUpdateGoods.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateGoods.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateGoods.vue?vue&type=style&index=0&id=7b2becf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2becf4",
  null
  
)

export default component.exports